
<div>
    <dynamic-table [props]="props">
        <table class="table">
            <thead>
                <tr class="table-header">
                    <th id="Fullname" class="table-header-title">{{'adminUsers.fullname' | translate}}</th>
                    <th id="Email" class="table-header-title">{{'adminUsers.email' | translate}}</th>
                    <th id="Phone" class="table-header-title">{{'adminUsers.phone' | translate}}</th>
                    <th id="Active" class="table-header-title l-table-width-250">{{'users.isActive' | translate}}</th>
                    <th class="table-header-title l-table-width-80"></th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let adminUser of users; let userIndex = index">
                    <tr class="table-container row-container ccc ccc-table-row ccc-hover">
                        <td HJSuppress id="Fullname" class="column-content table-main-td cursor-pointer" (click)="redirectUserDetails(adminUser.userId)">
                            {{adminUser.name}}
                        </td>
                        <td HJSuppress id="Email" class="column-content">
                            {{adminUser.email}}
                        </td>
                        <td HJSuppress id="Phone" class="column-content">
                            {{adminUser.phone}}
                        </td>
                        <td id="IsActive" class="column-content">
                            <kendo-switch [(ngModel)]="adminUser.isActive"
                                name="users-switch-{{userIndex}}"
                                (valueChange)="changeUserStatus(adminUser.userId, $event)"
                                [disabled]="myUserId === adminUser.userId"
                            >
                            </kendo-switch>
                        </td>

                        <td class="column-content">
                            <button class="btn delete-btn gap-2"
                                [disabled]="myUserId === adminUser.userId"
                                (click)="myUserId !== adminUser.userId && redirectUserDetails(adminUser.userId)">
                                <i class="app-icon icon icon-edit icon-lg me-2 text-secondary"></i>
                                <span>{{'users.add.placeholder.userDetails' | translate}}</span>
                            </button>
                        </td>

                        <td class="column-content">
                            <button class="btn delete-btn delete-btn-circle"
                                [disabled]="myUserId === adminUser.userId"
                                (click)="myUserId !== adminUser.userId && deleteUser(adminUser.userId)">
                                <i class="app-icon icon icon-delete icon-lg"></i>
                            </button>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </dynamic-table>
</div>
